export const numberFormat = (number, decimals, decPoint, thousandsSep, noZeroDecimal) => { // source: https://locutus.io/php/strings/number_format/

    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
    const dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
    let s = '';

    const toFixedFix = function (n, prec) {
        if (('' + n).indexOf('e') === -1) {
            return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
        } else {
            const arr = ('' + n).split('e');
            let sig = '';
            if (+arr[1] + prec > 0) {
                sig = '+';
            }
            return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
        }
    }

    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }

    if (s[1] && parseInt(s[1], 10) === 0 && noZeroDecimal) {
        return s[0];
    }

    return s.join(dec);
}

export default numberFormat;

export const formatPrice = (appData, value, decimals, stripZeroDecimals = true) => {
    const decimalPlaces = decimals === false ? 0 : appData.config.marketConfig.decimalPlaces;
    const price = `${appData.config.marketConfig.currencySymbol} ${numberFormat(value, decimalPlaces, appData.config.marketConfig.decimalSeparator, appData.config.marketConfig.thousandsSeparator, true)}`;
    return price;
}

export const formatMileage = (appData, value, decimals, stripZeroDecimals = true) => {
    const decimalPlaces = decimals === false ? 0 : appData.config.marketConfig.decimalPlaces;
    const mileage = `${numberFormat(value, decimalPlaces, appData.config.marketConfig.decimalSeparator, appData.config.marketConfig.thousandsSeparator, true)}`;
    return mileage;
}

